import { createFeatureSelector, createSelector, DefaultProjectorFn } from '@ngrx/store';
import { ACCOUNTS_STATE_KEY, accountsAdapter, IAccountsState } from '../reducers/accounts.reducer';
import { IAccount } from '../../../shared/models';
import { MemoizedSelector } from '@ngrx/store/src/selector';

const { selectIds, selectEntities, selectAll } = accountsAdapter.getSelectors();

export const selectAccountsState = createFeatureSelector<IAccountsState>(ACCOUNTS_STATE_KEY);

const selectAccountIds = createSelector(selectAccountsState, selectIds);
const selectAccountEntities = createSelector(selectAccountsState, selectEntities);
const selectAccounts = createSelector(selectAccountsState, selectAll);
const selectActiveAccounts = createSelector(selectAccounts, (accounts) =>
  accounts.filter((account) => account.accountIsActive),
);
const selectActiveAccountIds = createSelector(selectActiveAccounts, (accounts) =>
  accounts.map(({ accountId }) => accountId),
);
const isLoading = createSelector(selectAccountsState, ({ loading }) => loading);
const isError = createSelector(selectAccountsState, ({ error }) => Boolean(error));
const selectAccountsWithStatus = createSelector(selectAccounts, isLoading, (accounts, isLoading) => ({
  accounts,
  isLoading,
}));
const selectAccountById = (id?: number | null): MemoizedSelector<object, IAccount, DefaultProjectorFn<IAccount>> =>
  createSelector(
    selectAccountEntities,
    (dictionary): IAccount => (id && dictionary[id] ? (dictionary[id] as IAccount) : ({} as IAccount)),
  );
const selectAccountsByIds = (ids: number[]): MemoizedSelector<object, IAccount[], DefaultProjectorFn<IAccount[]>> =>
  createSelector(selectAccountEntities, (dictionary): IAccount[] =>
    (ids ?? []).map((id) => dictionary[id] as IAccount),
  );
const isSingleAccountUser = createSelector(selectAccounts, (accounts) => accounts.length === 1);

export const ACCOUNTS_SELECTORS = {
  selectAccountIds,
  selectAccountEntities,
  selectAccounts,
  selectActiveAccounts,
  isLoading,
  selectAccountsWithStatus,
  selectAccountById,
  selectAccountsByIds,
  isSingleAccountUser,
  isError,
  selectActiveAccountIds,
};
